module.exports = __webpack_public_path__ + "img/image-3.ab60af0f.png";